
import Http from 'Api/http';
import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { filtersToDto } from './dto/filtersDto';

/**
 * manda la petición para exportar en una tarea de célery las cotizaciones :)
 */
const exportInBackendQuotationList = ({ filters, state, emails }) => new Promise((resolve, reject) => {
    new Http({
        full_url: `${BACKEND_URL_QUOTATION}export/`,
        method: 'GET',
    }).fetch({
        data: {
            ...filtersToDto(filters),
            state,
            emails,
        },
        success: resolve,
        error: reject,
    });
});

export default exportInBackendQuotationList;
